import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=48e57f0a&scoped=true&"
import script from "./credits.vue?vue&type=script&lang=js&"
export * from "./credits.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./credits.vue?vue&type=style&index=0&id=48e57f0a&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "48e57f0a",
  "b5b7c2ba"
  
)

export default component.exports